<template>
    <Header
        :page-title="title"
    ></Header>
    <pageTool></pageTool>
    <div class="page-content">
        <div class="page-form">
            <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" ref="formRef">
                <div class="mla-form">
                    <div class="mla-form-title"><p>基本信息</p><div></div></div>
                    <a-form-item label="联系人" name="contactsName">
                        <a-input v-model:value="formState.contactsName"  placeholder="请输入联系人姓名"/>
                    </a-form-item>
                    <a-form-item label="所在镇街" name="TownType">
                        <a-select v-model:value="formState.TownType" placeholder="请选择所在镇街">
                            <a-select-option value="5169">孙集镇</a-select-option>
                            <a-select-option value="6148">经济开发区</a-select-option>
                            <a-select-option value="5172">张坊镇</a-select-option>
                            <a-select-option value="5165">郑路镇</a-select-option>
                            <a-select-option value="5170">韩庙镇</a-select-option>
                            <a-select-option value="5162">殷巷镇</a-select-option>
                            <a-select-option value="5167">玉皇庙镇</a-select-option>
                            <a-select-option value="5163">怀仁镇</a-select-option>
                            <a-select-option value="5164">龙桑寺镇</a-select-option>
                            <a-select-option value="6048">许商街道</a-select-option>
                            <a-select-option value="5166">贾庄镇</a-select-option>
                            <a-select-option value="5171">沙河镇</a-select-option>
                            <a-select-option value="5168">白桥镇</a-select-option>
                        </a-select>
                    </a-form-item>
<!--                    <a-form-item label="所在社区" name="address">-->
<!--                        <a-input v-model:value="formState.address"  placeholder="请输入所在村居或社区"/>-->
<!--                    </a-form-item>-->
                    <a-form-item label="联系电话" name="contactsPhone">
                        <a-input v-model:value="formState.contactsPhone"  placeholder="请输入联系电话" style="margin-bottom: 10px"/>
<!--                        <a-input v-model:value="formState.phoneCode" @blur="blurCode(formState.phoneCode)" style="width: 180px"  placeholder="验证码"/>-->
<!--                        <div @click="changeCode()" style="width: 180px"><Code :identifyCode="identifyCode"/></div>-->
                    </a-form-item>
                </div>
                <a-form-item :wrapper-col="{ span: 24, offset: 5 }">
                    <a-button type="primary" @click="onSubmit" size="large" class="cus-button">注册</a-button>
                </a-form-item>
            </a-form>
        </div>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import pageTool from '@/components/nav/pageTool'
import {reactive, ref} from "vue"
import { notification } from 'ant-design-vue'
import { sendPhoneCode, addSmallFarmersUserApi } from '@/api/directories'

// import Code from '@/components/SIdentify'

const banner = require('@/assets/img/page_banner_1.png')
export default {
    name: "DirectoryRegister",
    data(){
        return {
            identifyCode:""
        }
    },
    setup() {
        const title = {
            cn: '小农户注册',
            en: 'DIRECTORY REGISTER',
            hasSearch: false,
            titleStyle: false,
            banner
        }
        const loading = reactive({
            codeLoading: false,
            codeText: '发送验证码',
            isCode: false
        })
        const formState = reactive({
            contactsName: undefined,
            TownType: undefined,
            // address: undefined,
            contactsPhone: undefined,
            // phoneCode: undefined,
        })
        const checkPhone = (phone) =>{
            if(!(/^1[3456789]\d{9}$/.test(phone))){
                return false
            } else {
                return true
            }
        }
        const sendCode = () => {
            const mobileCheck = checkPhone(formState.contactsPhone)
            if (!mobileCheck) {
                notification.error({ message: '手机号格式不正确，请重新输入！', duration: 1.5, description: '' })
                return
            } else {
                let timeClock
                sendPhoneCode(formState.contactsPhone).then((res) => {
                    if (res == '发送成功') {
                        loading.codeLoading = true
                        loading.isCode = true
                        let time = 60
                        timeClock = setInterval(() => {
                            time --
                            loading.codeText = time+'秒后重试'
                            if (time == 0) {
                                clearInterval(timeClock)
                                loading.codeLoading = false
                                loading.codeText = '发送验证码'
                            }
                        }, 1000)
                    }
                })
            }
        }
        const rules = {
            contactsName: [{required: true,message: '请输入联系人',trigger: 'blur'}],
            TownType: [
                {
                    required: true,
                    message: '请选择所在镇街',
                    trigger: 'blur',
                },
            ],
            address: [{required: true,message: '请输入所在社区/村',trigger: 'blur'}],
            phoneCode: [{required: true,message: '请输入验证码',trigger: 'blur'}],
            contactsPhone: [{required: true,message: '请输入手机号',trigger: 'blur'}],
        }
        const register = async(params) => {
            const data = await addSmallFarmersUserApi(params)
            if (data) {
                notification.success({ message: '提交成功！', duration: 2.5, description: '' })
                setTimeout(() => {
                    location.reload()
                }, 2000)
            }
        }
        const formRef = ref()
        const onSubmit = () => {
            // 要验证loading.isCode是否为true
            formRef.value
                .validate()
                .then(() => {
                    const params = {
                        name: formState.contactsName, //联系人姓名
                        townid: formState.TownType, //所属乡镇
                        // address: formState.address, //所在地址
                        account: formState.contactsPhone, //联系人电话,
                        // verCode: formState.phoneCode, // 验证码
                    }
                    register(params)
                })
                .catch(error => {
                    console.log('error', error);
                })
        }
        return {
            title,
            labelCol: {
                span: 6,
            },
            wrapperCol: {
                span: 16,
                offset: 2
            },
            formState,
            loading,
            rules,
            formRef,
            onSubmit,
            sendCode,
            checkPhone,
            register
        }
    },
    mounted() {
        this.changeCode()
    },
    methods: {
        getLocal() {
            this.iframeStyle = true
        },
        changeCode(){
            const index1 = Math.round(Math.random() * (60));
            const index2 = Math.round(Math.random() * (60));
            const index3 = Math.round(Math.random() * (60));
            const index4 = Math.round(Math.random() * (60));
            const  arr = "0123456789qwertyuiopasdfghjklzxcvbnmQAZWSXEDCRFVBGTYHNMJUIKOL";
            const code1=arr.substring(index1,index1+1);
            const code2=arr.substring(index2,index2+1);
            const code3=arr.substring(index3,index3+1);
            const code4=arr.substring(index4,index4+1);
            this.identifyCode=code1+""+code2+""+code3+""+code4
        },
        blurCode(val){
            if(val.length>0){
                if(val.toLowerCase()!=this.identifyCode.toLowerCase()){
                    notification.error({ message: '验证码输入错误,请核对后重新输入', duration: 1.5, description: '' })
                    this.changeCode();//刷新验证码
                    return
                }
            }
        }
    },
    components: {
        Header,
        pageTool,
        // Code
    }
}
</script>

<style scoped lang="stylus">
.page-content {
    width 100%
    height 100%
    padding 10px 15px
    .page-form {
        width 100%
        //height 100%
        background-color #FFF
        border-radius 3px
        box-shadow 1px 1px 5px #22222247
        padding 15px
        .iframe-style {
            width 100%
            height 0
        }
        .iframe-style-large {
            width 100%
            height 500px
        }
        .cus-button {
            width 199px
            background #03CA8F
            border-radius 6px
            border-color #03CA8F
        }
        .code-button {
            background #03CA8F
            border-radius 6px
            border-color #03CA8F
        }
        .line-title {
            width 96%
            height 26px
            line-height 26px
            color #03CA8F
            font-size 12px
            font-weight bolder
            border-bottom 1px solid #03CA8F
            margin-bottom 15px
        }
    }
    .page-form >>> .ant-form-item {
        margin-bottom 0
    }
    .page-form >>> .ant-checkbox-wrapper + .ant-checkbox-wrapper {
        margin-left 0
    }
    .page-form >>> .ant-input:hover {
        border-color #03CA8F
    }
    .page-form >>> .ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner, .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color #03CA8F !important
    }
    .page-form >>> .ant-checkbox-checked .ant-checkbox-inner {
        border-color #03CA8F !important
        background-color: #03CA8F
    }
}

@media (max-width: 575px) {
    .page-form >>> .ant-form-item-label {
        line-height 10.667vw
    }
}
</style>
